module.exports = __webpack_public_path__ + "img/zerocoma.8816024c.png";